// extracted by mini-css-extract-plugin
export default {"header":"DocumentCaptureHeaderAndSummary__header-tPD1"};